import Link from 'next/link';
import React, { FC } from 'react';
import { RightArrow } from '../../../../atoms/icons/arrow/RightArrow';
import css from './style.module.scss';
import { buildSiteUrl } from 'src/utils/request-url';

type Props = {
  coupon: { name: string; publicId: string };
};

export const CouponLinkCard: FC<Props> = ({ coupon }) => {
  return (
    <Link
      href={buildSiteUrl(`/coupons/${coupon.publicId}`, 'next')}
      prefetch={false}
      className={css.link}
    >
      <div className={css.link_flex_justify_between}>
        <div>
          <span className={css.link_text}>{coupon.name}</span>
        </div>
        <div className={css.arrow_icon}>
          <RightArrow />
        </div>
      </div>
    </Link>
  );
};
